/*
 * Enrol selector (homepage + /pages/enroll).
 *
 * Two inline steps, no intermediate pages:
 *   1. Choose a school  -> the instrument field is revealed
 *   2. Choose an instrument -> the "Enrol" button activates
 *   3. Enrol -> straight to that school + instrument's tutor page
 *
 * All the data lives in the hidden ".schools-data" tree rendered by
 * sections/enroll_banner.liquid, which mirrors the "school" menu:
 *   .schools-data > .<school-handle> > .instrumentsname[data-title]
 *                                      > .tutorname[data-link]  (the tutor page)
 */
(function () {
  var schoolsData = document.querySelector(".schools-data");
  var instrumentSelect = document.querySelector(".instrument_select");
  var instrumentContainer = document.querySelector(".instrument_container");
  var enrolBtn = document.querySelector(".enroll_search_btn");

  // Not the enrol page/homepage -> nothing to wire up.
  if (!schoolsData || !instrumentSelect || !enrolBtn) return;

  var selectedTutorUrl = "";

  function setEnrolEnabled(on) {
    enrolBtn.classList.toggle("is-disabled", !on);
  }

  function resetInstruments() {
    instrumentSelect.innerHTML =
      '<option value="" disabled selected>Choose an instrument</option>';
    selectedTutorUrl = "";
    setEnrolEnabled(false);
    if (instrumentContainer) instrumentContainer.classList.remove("is-visible");
  }

  function findSchool(handle) {
    if (!handle) return null;
    try {
      return schoolsData.querySelector(handle); // handle is a class selector, e.g. ".aberdeen-school"
    } catch (e) {
      return null;
    }
  }

  function populateInstruments(handle) {
    resetInstruments();

    var schoolEl = findSchool(handle);
    if (!schoolEl) return;

    var added = 0;
    schoolEl.querySelectorAll(".instrumentsname").forEach(function (ins) {
      var name = ins.getAttribute("data-title");
      var tutor = ins.querySelector(".tutorname[data-link]");
      var link = tutor ? tutor.getAttribute("data-link") : "";
      if (!name || !link) return; // skip instruments with no tutor

      var opt = document.createElement("option");
      opt.value = link; // the tutor's enrolment page
      opt.textContent = name;
      instrumentSelect.appendChild(opt);
      added++;
    });

    if (added > 0 && instrumentContainer) {
      instrumentContainer.classList.add("is-visible");
    }
  }

  // Step 1 -> fired by the Semantic UI school dropdown (initialised in the section markup).
  document.addEventListener("mh:school-selected", function (e) {
    populateInstruments(e && e.detail ? e.detail.handle : "");
  });

  // Step 2 -> an instrument (and therefore its tutor page) has been chosen.
  instrumentSelect.addEventListener("change", function () {
    selectedTutorUrl = this.value || "";
    setEnrolEnabled(!!selectedTutorUrl);
  });

  // Step 3 -> go straight to the tutor's enrolment page.
  enrolBtn.addEventListener("click", function () {
    if (selectedTutorUrl) window.location.href = selectedTutorUrl;
  });

  // Backwards compatibility: /pages/enroll?schoolname=.<handle> preselects the school.
  if (window.location.href.indexOf("?schoolname=") !== -1) {
    var handle = decodeURIComponent(
      window.location.href.split("?schoolname=")[1].split("&")[0]
    );
    var item = document.querySelector(
      '.school_dropdown .item[data-school="' + handle + '"]'
    );
    if (item) {
      var textEl = document.querySelector(".school_dropdown > .text");
      if (textEl) {
        textEl.textContent = item.textContent;
        textEl.classList.remove("default");
      }
    }
    populateInstruments(handle);
  }
})();
